module.exports = __webpack_public_path__ + "img/techdata.6a208c2d.jpg";